import React from 'react';
import { Chip, Stack, Typography } from '@mui/material';
import { ExpandCircleDown } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

interface Props {
  showMoreDetails?: boolean;
  onClick?: () => void;
}

const PatientDetailsChip = ({ showMoreDetails, onClick }: Props): JSX.Element => {
  const theme = useTheme();
  return (
    <Chip
      data-testid="more-details-button"
      size="small"
      onClick={onClick}
      sx={{ '& .MuiChip-label': { pr: '3px' } }}
      aria-expanded={showMoreDetails}
      label={
        <Stack direction="row" alignItems="center" justifyContent="space-between" minWidth="114px" p={0}>
          <Typography variant="body2">{showMoreDetails ? 'Hide details' : 'More details'}</Typography>
          <ExpandCircleDown
            fontSize="small"
            sx={{
              transform: showMoreDetails ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: theme.transitions.create('transform'),
            }}
          />
        </Stack>
      }
    />
  );
};

export default PatientDetailsChip;
